<template>
    <div class="columns center">
        <div class="table-container center-column">
            <table v-if="isLoaded" class="table is-responsive is-fullwidth">
                <thead>
                <tr>
                    <th>#ID</th>
                    <th>Name</th>
                    <th>Auction</th>
                    <th>Yokohama</th>
                    <th>Yokohama(sales)</th>
                    <th>Nagoya</th>
                    <th>Nagoya(sales)</th>
                    <th>Kobe</th>
                    <th>Kobe(sales)</th>
                    <th>Hakata</th>
                    <th>Hakata(sales)</th>
                    <th>Info</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                    <inland-company-table-row v-for="company in companies" :company="company"></inland-company-table-row>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import InlandCompanyTableRow from './InlandCompanyTableRow.vue'
    export default {
        components: {
            InlandCompanyTableRow
        },
        computed: {
            companies () {
                return this.$store.getters.getInlandCompanies
            },
            isLoaded () {
                return this.$store.getters.getInlandCompanyLoadingStatus
            }
        },
        created() {
            this.$store.dispatch('fetchAllInlandCompanies')
        }
    }
</script>

<style scoped>
    .table-container {
        padding-top: 20px;
        max-width: 100%;
    }
    .is-responsive-table th {
        font-size: small;
    }
    .long {
        min-width: 75px;
    }
    .link {
        border-bottom: 1px solid blue;
        cursor: pointer;
    }
    .center, .center-column, .top, .right, .bottom, .left {
        justify-content: center;
        align-items: center;
    }
    th {
        font-size: small;
    }
</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/InlandComapnies/InlandCompaniesTable.vue